// client/src/components/Finances/FinancialDocuments.js

export default function FinancialDocuments({ documents }) {
  if (!documents || documents.length === 0) {
    return (
      <div className="bg-white shadow rounded-xl p-6">
        <h2 className="text-lg font-semibold mb-4">Financial Documents</h2>
        <p className="text-sm text-gray-500">
          No financial documents uploaded yet.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white shadow rounded-xl p-6">
      <h2 className="text-lg font-semibold mb-4">Financial Documents</h2>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {documents.map((doc) => (
          <div
            key={doc.id}
            className="
              border 
              rounded-lg 
              p-4 
              bg-gray-50 
              hover:bg-gray-100 
              cursor-pointer 
              transition 
              flex 
              flex-col 
              justify-between
            "
            onClick={() => {
              // Later: open preview modal or navigate to DocumentsTab pre-filtered
              console.log("Open document:", doc);
            }}
          >
            <div>
              <p className="font-medium text-sm text-gray-900">
                {doc.name || "Untitled Document"}
              </p>

              <p className="text-xs text-gray-500 mt-1 capitalize">
                {doc.type || "document"}
              </p>
            </div>

            {doc.uploadedAt && (
              <p className="text-[10px] text-gray-400 mt-3">
                Uploaded {new Date(doc.uploadedAt).toLocaleDateString()}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
